
<form *ngIf="!load" [formGroup]="form" (ngSubmit)="onSaveData()" class="form-group	edit-form">
	<div class="col-md-8 d-flex flex-wrap">
		<ng-container *ngFor="let item of formData; let i = index" >
			<ng-container *ngIf="item.hide != true" >
				<div [ngSwitch]="item?.type" [class]="'div-input ' + item.class">
					<label class="col-12 pe-2">
						<b class="pb-1" *ngIf="item.type != 'slide'">{{item?.label}}
							<sup *ngIf="item.hasModal" class="sup-icon-modal-help">
								<span class="icon-modal-help" (click)="item.openModal()">help</span>
							</sup>
							<sup *ngIf="item.required" class="text-danger ms-2">*</sup>
						</b>
						<input *ngSwitchDefault [id]="item.key" [type]="item.type" class="form-control" 
							[formControlName]="item.key" placeholder="Digite " [readonly]="item.readonly ?? false"/>

						<input *ngSwitchCase="'datetime-local'" [id]="item.key" [type]="item.type" class="form-control" 
							[formControlName]="item.key" placeholder="Digite " max="9999-12-31" 
							(click)="openDatePicker($event)"/>

						<input *ngSwitchCase="'phone'" [id]="item.key" class="form-control" 
							[formControlName]="item.key" (input)="maskPhone(item.key, $event)" placeholder="XXXXX-XXXX">
							
						<input *ngSwitchCase="'money'" [id]="item.key" class="form-control" type="number"
							[formControlName]="item.key" (input)="maskMoney(item.key, $event)" placeholder="XXXXX.XX">
						
						<input *ngSwitchCase="'integer'" [id]="item.key" class="form-control" type="number"
							[formControlName]="item.key" (input)="maskInteger(item.key, $event)" placeholder="XXXXX">

						<input *ngSwitchCase="'cpf'" [id]="item.key" class="form-control"
							[formControlName]="item.key" (input)="maskCpf(item.key, $event)" placeholder="XXX.XXX.XXX-XX">
							
						<textarea *ngSwitchCase="'textArea'" [id]="item.key" class="form-control"
							[formControlName]="item.key" placeholder="Digite " [readonly]="item.readonly ?? false"></textarea>
						
						<ng-select *ngSwitchCase="'select'" [readonly]="item.readonly" [id]="item.key" class="ng-select-alternative"
							[items]="item.options" bindLabel="label" [formControlName]="item.key" placeholder="Selecione" bindValue="id">

							<ng-template ng-header-tmp *ngIf="valueNotInOptions(item)">
								<div class="ng-option ng-option-disabled">
									A opção selecionada não está ativa.
								</div>
							</ng-template>
							<ng-template ng-notfound-tmp>
								<div class="ng-option ng-option-disabled">
									Nenhuma opção encontrada.
								</div>
							</ng-template>
						</ng-select>
						
						<mat-select class="select-icon form-control" [formControlName]="item.key" *ngSwitchCase="'selectIcon'" [compareWith]="compareFunction" >
							<mat-option *ngFor="let opt of item.options" [value]="opt['id']">
								<span	class="icon-option">
									<img [src]="'assets/images/svgs/' + opt['icon'] + '.svg'" alt="{{opt['label']}}" />
									<span>{{ opt['label'] }}</span>
								</span>
							</mat-option>
						</mat-select>
	

						<div *ngSwitchCase="'multSelect'">
							<div [formArrayName]="item.key"	*ngFor="let opt of getFormArray(item.key).controls; let i = index" class="m-b mult-select">
								<div class="col-10 col-sm-11">
									<ng-select [id]="item.key + i" class="ng-select-alternative" [items]="item.options"
										bindLabel="label" bindValue="id" placeholder="Selecione" [formControlName]="i"
										notFoundText="Selecione o Exercício">
									</ng-select>
								</div>
								<div class="div-button col-2 col-sm-1 d-flex justify-content-end">
									<button class="btn btn-font-icon" type="button" (click)="removeItem(item.key, i)" alt="Remover órgão fixo">
										delete
									</button>
								</div>
							</div>
							<div class="d-flex justify-content-end">
								<button class="btn btn-blue-1" type="button" (click)="addItem(item.key)" alt="Adicionar órgão participante">
									Novo
								</button>
							</div>
						</div>
						
						<div *ngSwitchCase="'multString'">
							<div	[formArrayName]="item.key"	*ngFor="let opt of getFormArray(item.key).controls; let i = index" class="m-b mult-select">
								<div class="col-10 col-sm-11">
									<input *ngSwitchDefault [id]="item.key" [type]="item.type" class="form-control" 
										[formControlName]="i" placeholder="Digite " />
								</div>
								<div class="div-button col-2 col-sm-1 d-flex justify-content-end">
									<button class="btn btn-font-icon" type="button" (click)="removeItem(item.key, i)" alt="Remover órgão fixo">
										delete
									</button>
								</div>
							</div>
							<div class="d-flex justify-content-end">
								<button class="btn btn-blue-1" type="button" (click)="addItem(item.key)" alt="Adicionar órgão participante">
									Novo
								</button>
							</div>
						</div>

						<div *ngSwitchCase="'listSlide'" class="d-grid" [formArrayName]="item.key">
							<ng-container *ngFor="let opt of item.options; let i = index" [formGroupName]="i" >
								<mat-slide-toggle class="slide-toggle mb-2" formControlName="status">
									{{ opt['label'] }}
								</mat-slide-toggle>
							</ng-container>
						</div>
						
						<div *ngSwitchCase="'slide'" class="d-grid">
							<mat-slide-toggle class="slide-toggle mb-2" [formControlName]="item.key">
									{{ item['label'] }} <sup *ngIf="item.required" class="text-danger ms-2">*</sup>
								</mat-slide-toggle>
						</div>

						<div *ngSwitchCase="'color'" class="form-control color-control">
								<input type="color" [formControlName]="item.key" (input)="onColorChange(item.key, $event)" />
								<input type="text" [formControlName]="item.key" maxlength="7" style="width: 80px;" (input)="onColorChange(item.key, $event)" />
						</div>

						<div *ngSwitchCase="'iconGoogle'" class="icon-google">
							<input [id]="item.key" [type]="item.type" class="form-control" 
								   [formControlName]="item.key" placeholder="Digite " />
							<span class="font-icon-google">{{form.get(item.key)?.value}}</span>
						</div>

						<div *ngSwitchCase="'dragList'" cdkDropList (cdkDropListDropped)="drop($event, item.key)" class="grid-drop">
							<div class="m-b drop-row-header">
								<div class="mult-select col-12">
									<div class="col-1 col-sm-1"></div>
									<div class="col-8 col-sm-9">
										<label><b class="pb-1">Nome</b></label>
									</div>
									<div class="div-button col-1 col-sm-1 d-flex">
										<label><b class="pb-1">Ordem</b></label>
									</div>
									<div class="div-button col-2 col-sm-1 d-flex">
										<label><b class="pb-1">Ação</b></label>
									</div>
								</div>
							</div>
							<div [formArrayName]="item.key"	*ngFor="let opt of getFormArray(item.key).controls; let i = index" class="drop-row">
								<div class="mult-select select-drag col-12" cdkDrag cdkDragLockAxis="y" [cdkDragData]="opt">
									<div class="col-1 col-sm-1 grab-icon">
										<span class="font-icon"> 
											drag_indicator
										</span>
									</div>
									<div class="col-8 col-sm-9 d-flex align-items-center">
										<p class="m-0">{{valueOfObj(item, i)}}</p>
									</div>
									<div class="div-button col-1 col-sm-1 d-flex">
										<input [id]="item.order[i].ordem + '_' + item.order[i].ordem" [value]="orderOfObj(item, i)" type="text" class="form-control" readonly="true"/>
									</div>
									<div class="div-button col-2 col-sm-1 d-flex">
										<button class="btn btn-font-icon" type="button" (click)="removeDragItem(item.key, i)" alt="Remover órgão fixo">
											delete
										</button>
									</div>
								</div>
							</div>
							<div class="d-flex mult-select">
								<div class="col-1 col-sm-1 font-icon"></div>
								<div class="col-8 col-sm-9">
									<ng-select [id]="item.key + 'optionList'" class="ng-select-alternative" [items]="item.optionsList"
										bindLabel="label" bindValue="id" placeholder="Selecione" notFoundText="Selecione"
										(change)="onSelectChange($event)">
									</ng-select>
								</div>
								<div class="div-button col-1 col-sm-1 d-flex">
									<input [id]="item.ordem" type="text" class="form-control" readonly="true"/>
								</div>
								<div class="div-button col-2 col-sm-1 d-flex">
									<button class="btn btn-blue-1 btn-font-icon" type="button" (click)="addDragItem(item.key)" alt="Adicionar">
										add
									</button>
								</div>
							</div>
						</div>
					</label>
					<div *ngSwitchCase="'multItems'" class="table-component">
						<table>
							<thead>
								<tr>
									<th></th>
									<th class="text-center">Ordem</th>
									<th class="item-column">Item</th>
									<th>Permite Branco</th>
									<th></th>
								</tr>
							</thead>
							<tbody [formArrayName]="item.key"	cdkDropList [cdkDropListDisabled]="false"
								(cdkDropListDropped)="orderItem($event, item.key)">
								<tr *ngFor="let opt of getFormArray(item.key).controls; let i = index" class="m-b "
									cdkDrag cdkDragLockAxis="y" [formGroupName]="i" >
										<td class="align-middle td-drag" cdkDragHandle >
											<span class="font-icon icon-drag"	> 
												drag_indicator
											</span>
										</td>
										<td class="text-center td-select" >
											<ng-select id="ordem" class="ng-select-alternative" [items]="orderList"	(change)="setOrdemItem($event, opt.value, item.key)"
												bindLabel="label" bindValue="id" formControlName="ordem" [clearable]="false">
											</ng-select> 
										</td>
										<td	class="item-column">
											<ng-select id="item" class="ng-select-alternative" [items]="item.options" 
												bindLabel="label" bindValue="id" formControlName="item" [clearable]="false">
											</ng-select> 
										</td>
										<td>
											<ng-select id="permiteBranco" class="ng-select-alternative" [items]="currentActive"
												bindLabel="label" bindValue="id" formControlName="permiteBranco" [clearable]="false">
											</ng-select>
										</td>
										<td class="action-column">
											<button class="btn btn-font-icon" type="button" (click)="removeItem(item.key, i); recalcOrder(item.key);" alt="Remover órgão fixo">
												delete
											</button>
										</td>
								</tr>
							</tbody>
						</table>
						<div class="d-flex justify-content-end">
							<button class="btn btn-blue-1" type="button" (click)="addGroupItem(item.key)" alt="Adicionar órgão participante">
								Novo
							</button>
						</div>
					</div>
					<hr *ngSwitchCase="'hr'">
					<div class="NgxEditor__Wrapper" *ngSwitchCase="'textEditor'">
						<ngx-editor-menu [editor]="editor[i]" [toolbar]="toolbar">	</ngx-editor-menu>
						<ngx-editor [editor]="editor[i]" [formControlName]="item.key" [disabled]="false" [placeholder]="'Digite aqui....'"></ngx-editor>
					</div>

					<app-field-message *ngIf="item?.type != 'hr'" class="field-error" [field]="fieldMessageRequired(item.key)" [textErroServer]="item.error ?? null" [erros]="fieldErros(item.key)"></app-field-message>
					
				</div>
			</ng-container>
		</ng-container>
	</div>

	<hr class="final-line">
	<div class="col-12 d-flex justify-content-end my-4" *ngIf="showActions">
		<button class="btn btn-white-1 m-r-xs" type="button" (click)="back()" alt="Voltar">Voltar</button>
		<ng-content></ng-content>
		<button class="btn btn-red-1 m-r-xs" *ngIf="canDelete" (click)="onDeleteData()" type="button">Excluir</button>
		<button class="btn btn-blue-1" type="submit">Salvar</button>
    </div>
</form>